//@ts-check
import { useState, useEffect } from "react";
import mbFetch from "mibaby-common/util/fetch";
import useMounted from "mibaby-frontend/util/hooks/useMounted";
/**
 * @returns {[
 *  string,
 *  string,
 *  import('mibaby-frontend/types').SupportedMimeTypes,
 *  import('mibaby-frontend/types').AssetVersion
 * ]}
 */
export default (id, assetId) => {
  /**
   * @typedef {{
   *  html?: string,
   *  detail_asset_mimetype?: import('mibaby-frontend/types').SupportedMimeTypes,
   *  detail_asset_versions?: import('mibaby-frontend/types').AssetVersion
   * }} Content
   *
   * @type {[Content, (content: Content) => void]}
   */
  const [{ html, detail_asset_mimetype, detail_asset_versions }, setContent] = useState({});
  /** @type {[string, (status: string) => void]} */
  const [status, setStatus] = useState();
  const mounted = useMounted();

  // Load detail data
  const fetchDetails = async () => {
    try {
      setStatus("loading");
      const response = await mbFetch(`/content_feeds/detail/${id}/${assetId}`);
      if (response.ok) {
        const json = await response.json();
        if (!mounted.current) {
          // cancel here, if unmounted
          return;
        }
        setContent(json);
        setStatus("loaded");
      } else {
        throw new Error("response not ok");
      }
    } catch (e) {
      setStatus("Leider ging da was schief!");
    }
  };
  useEffect(() => {
    id && fetchDetails();
  }, [id, assetId]);
  return [status, html, detail_asset_mimetype, detail_asset_versions];
};
